var _circle, _circle2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "USDT",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.001,
    viewBox: "0 0 24 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_740",
    "data-name": "Elipse 740",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#00eed1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_741",
    "data-name": "Elipse 741",
    cx: 10.345,
    cy: 10.345,
    r: 10.345,
    transform: "translate(1.656 1.5)",
    fill: "#00ddc2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43081",
    "data-name": "Caminho 43081",
    d: "M15.561,3a12.01,12.01,0,0,1,.286,1.662A10.345,10.345,0,1,1,5.539,17.784a12.145,12.145,0,0,1-1.624.112h-.06A12,12,0,1,0,15.561,3Z",
    transform: "translate(-3.502 -3)",
    fill: "#00ddc2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43082",
    "data-name": "Caminho 43082",
    d: "M17.889,27.7a10.345,10.345,0,0,0,.346-20.681A11.948,11.948,0,0,1,7.928,20.141,10.345,10.345,0,0,0,17.889,27.7Z",
    transform: "translate(-5.889 -5.521)",
    fill: "#00ccb3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43083",
    "data-name": "Caminho 43083",
    d: "M28.69,19H21.241a1.241,1.241,0,1,0,0,2.483h2.483v8.69a1.241,1.241,0,0,0,2.483,0v-8.69H28.69a1.241,1.241,0,1,0,0-2.483Z",
    transform: "translate(-12.965 -13)",
    fill: "#f1f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43084",
    "data-name": "Caminho 43084",
    d: "M23.793,33.4c-.419,0-.847-.016-1.272-.046C20.336,33.2,18,32.589,18,31.336c0-.863,1.183-1.548,3.245-1.877a.414.414,0,0,1,.131.817c-1.906.3-2.548.856-2.548,1.06,0,.331,1.254,1.018,3.754,1.2a16.676,16.676,0,0,0,2.423,0c2.5-.179,3.754-.864,3.754-1.2,0-.2-.642-.755-2.548-1.06a.414.414,0,0,1,.131-.817c2.062.329,3.245,1.014,3.245,1.877,0,1.253-2.336,1.866-4.522,2.023C24.64,33.389,24.212,33.4,23.793,33.4Z",
    transform: "translate(-11.793 -18.955)",
    fill: "#e6e7e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.ce5a40c39758c9f0b1816478453f1516.svg";
export { ForwardRef as ReactComponent };